import { Icon } from './icon';

export const IconNext = () => (
  <Icon>
    <path d="M14.2827 5L20.9998 12L14.2827 19" />
    <line x1="19.7329" y1="12.0317" x2="3.99985" y2="12.0317" />
  </Icon>
);
